"use client";

import Image from "next/image";
import { useRef } from "react";
import galleryimg1 from "@/assets/club-society/gallery-club-1.jpg";
import galleryimg2 from "@/assets/club-society/gallery-club-2.jpg";
import galleryimg3 from "@/assets/club-society/gallery-club-3.jpg";
// import galleryimg4 from "@/assets/club-society/gallery-club-4.jpg";
import galleryimg5 from "@/assets/club-society/gallery-club-6.webp";

const celebrateItems = [
  {
    src: galleryimg1,
    alt: "Student learning film-making with camera",
  },
  {
    src: galleryimg2,
    alt: "Student playing guitar on stage",
  },
  {
    src: galleryimg3,
    alt: "Student practicing yoga indoors",
  },
   {
    src: galleryimg5,
    alt: "Students participating in community event",
  },
];

export default function CelebrateYouSection() {
  const scrollRef = useRef(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollStart = useRef(0);

  const getClientX = (e) =>
    "touches" in e ? e.touches[0].clientX : e.clientX;

  const handlePointerDown = (e) => {
    const container = scrollRef.current;
    if (!container) return;

    isDragging.current = true;
    startX.current = getClientX(e);
    scrollStart.current = container.scrollLeft;
    container.classList.add("grabbing");
  };

  const handlePointerMove = (e) => {
    const container = scrollRef.current;
    if (!container || !isDragging.current) return;

    e.preventDefault(); // stop vertical scroll while dragging
    const x = getClientX(e);
    const walk = x - startX.current;
    container.scrollLeft = scrollStart.current - walk;
  };

  const endDrag = () => {
    const container = scrollRef.current;
    if (!container) return;
    isDragging.current = false;
    container.classList.remove("grabbing");
  };

  return (
    <section className="bg-[#00314d] py-14 md:py-20">
      <div className="max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)]">
        {/* Heading + copy */}
        <div className="text-center max-w-4xl mx-auto mb-10 md:mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#fff] mb-4 leading-tight">
            At Medhavi, we celebrate YOU!
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-white/90 leading-relaxed">
            Every student is different in their interests, passions, and aspirations.
            Therefore, we believe in empowering you to design your own educational journey
            tailored to your individual needs and goals. From a diverse array of options,
            students have the freedom to customize a curriculum that aligns with their
            career ambitions and personal interests, fostering purposeful progression.
          </p>
        </div>

        {/* Scrollable image strip */}
        <div className="relative">
          <div
            ref={scrollRef}
            className="flex gap-6 md:gap-8 overflow-x-auto no-scrollbar select-none cursor-grab pb-4"
            onMouseDown={handlePointerDown}
            onMouseMove={handlePointerMove}
            onMouseLeave={endDrag}
            onMouseUp={endDrag}
            onTouchStart={handlePointerDown}
            onTouchMove={handlePointerMove}
            onTouchEnd={endDrag}
          >
            {celebrateItems.map((item, index) => (
              <div
                key={index}
                className="shrink-0 w-[75vw] sm:w-[45vw] md:w-[32vw] lg:w-[28vw]"
              >
                <div className="relative aspect-[4/5] bg-black/20 overflow-hidden  group">
                  <Image
                    src={item.src}
                    alt={item.alt}
                    fill
                    draggable={false}
                    onDragStart={(e) => e.preventDefault()}
                    className="object-cover transition-transform duration-500 group-hover:scale-105"
                    sizes="(max-width: 640px) 75vw, (max-width: 768px) 45vw, (max-width: 1024px) 32vw, 28vw"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Local utility styles */}
      <style jsx>{`
        .no-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .no-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .grabbing {
          cursor: grabbing;
          cursor: -webkit-grabbing;
        }
      `}</style>
    </section>
  );
}
